import Sidebar from "./Sidebar";
import Footer from "./Footer";

export default function Layouts({ children, sidebar = true, footer = true }) {
    return (
        <>
            {sidebar && <Sidebar />}
            <div style={{ paddingTop: sidebar ? "52px" : 0 }}>{children}</div>
            {footer && <Footer />}
        </>
    )
}